import React, { Component } from 'react';
import './App.css';
import './bookat.css';
import Resource from './components/Resource';
import Summary from './components/Summary';
import PropTypes from 'prop-types';
import Voucher from './components/Voucher';
import Confirmation from './components/Confirmation';

const scheduleAPI = process.env.REACT_APP_ALLDATA;
// const scheduleAPI = 'http://homestead.test/api/getalldata/';


class App extends Component {
  state = {
    bookingData: [],
    data: undefined,
    voucher: undefined,
    isLoading: true,
    isBooked: false,
    wrongData: false,
    masterData: undefined,
  };


  componentDidMount() {
    const { chained, hashId, match } = this.props;
    const bookingHash = match.params.id;

    let fetchData = scheduleAPI + hashId;

    if (chained) {
      fetchData = scheduleAPI + hashId + '?chain=1';
    }

    fetch(fetchData)
      .then(response => response.json())
      .then(data => this.setState({ data, isLoading: false }, this.handleVoucherData))
        .catch(e => this.setState({wrongData: true}));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log('new masterdata',this.state.masterData);
      if (prevState.bookingData !== this.state.bookingData) {
        const findIndex = this.state.bookingData.findIndex(({master: bookingDataMaster}) => bookingDataMaster === true);
        //todo we could probably set this when the booking is complete for better flow
        if (findIndex !== -1) {
          // En tid är vald som master
          // masterData = bookingData[findIndex];
          const masterData = this.state.bookingData[findIndex];

          this.setState({masterData});


        }

      }


  }

  handleVoucherData = () => {
    const { data } = this.state;

    if (data.voucher !== null) {
      this.setState({ voucher: data.voucher });
    }
  };

  handleComplete = (data) => {
    this.setState((prevState) => {
      const bookingData = [...prevState.bookingData];
      const findIndex = bookingData.findIndex(({ id }) => id === data.id);

      if (findIndex !== -1) {
        bookingData[findIndex] = { ...data };

        return { bookingData };
      }

      bookingData.push(data);

      return { bookingData };
    });
  };

  handleMasterData = (m) => {
    const pickedDate = new Date(m.getTime() - (m.getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
    const masterData = {id: 'group', date: {date: pickedDate}};
    this.setState({masterData})
  };

  handleInComplete = (data) => {
    // todo make it remember its position even if deleted.
    // todo Perhaps i can set it to undefined and filter before sending to props
    this.setState(prevState => (
      { bookingData: prevState.bookingData.filter(({ id }) => id !== data.id) }));

    /*
    this.setState((prevState) => {
      const bookingData = [...prevState.bookingData];
      const findIndex = bookingData.findIndex(({ id }) => id === data.id);

      if (findIndex !== -1) {
        const chosenData = bookingData[findIndex];

        if (chosenData.master === true) {
          return { bookingData: prevState.bookingData.filter(({ id, master }) => id !== data.id && master !== false) };
        }
      }
      return { bookingData: prevState.bookingData.filter(({ id }) => id !== data.id) };


    });
     */
  };


  handleVoucher = (data) => {
    // todo make it remember its position even if deleted.
    // todo Perhaps i can set it to undefined and filter before sending to props
    this.setState({ voucher: data });
  };

  setBookingComplete = (isBooked) => {
    this.setState({isBooked})
  };


  render() {
    const {
      isLoading, data, bookingData, voucher, isBooked, wrongData, masterData
    } = this.state;

    // todo remove now that it is unessasry
    if (isBooked) {
      return <Confirmation/>
    }


    const { hashId, chained } = this.props;

    if (wrongData) {
      //todo do this with route
      return (
          <div>Error 4156</div>
      );
    }

    if (isLoading) {
      return (
        <div>Loading</div>
      );
    }


    return (
      <div className="App">
        {data.resources.map(({
 id, participants, products, optionalProducts, defaultParticipants, schedule, master, beforeOrAfter, refreshSchedule, name, group
}) => (

  <Resource
    master={master}
    handleMasterData={this.handleMasterData}
    group={group}
    id={id}
    key={id}
    resourceName={name}
    participants={participants}
    defaultParticipants={defaultParticipants}
    products={products}
    optionalProducts={optionalProducts}
    schedule={schedule}
    lang={data.lang}
    onComplete={this.handleComplete}
    inComplete={this.handleInComplete}
    extras={[]}
    bookingData={bookingData}
    masterData={masterData}
    showBeforeOrAfter={beforeOrAfter}
    refreshSchedule={refreshSchedule}

  />

        ))}

        <Voucher
          voucher={this.handleVoucher}
          hashid={hashId}
          lang={data.lang.voucher}
        />

        <Summary
          hashId={hashId}
          lang={data.lang.summary}
          productSettings={data.resources[0].products ? data.resources[0].products.settings : data.resources[1].products.settings}
          voucher={voucher}
          inputFields={data.inputFields}
          bookingData={bookingData}
          setBookingComplete={this.setBookingComplete}
        />

        {1 === 2 && (
          <pre>{JSON.stringify(voucher, null, 2)}</pre>
        )}

      </div>
    );
  }
}

App.propTypes = {
  hashId: PropTypes.string.isRequired,
  chained: PropTypes.bool.isRequired,

};

export default App;



// WEBPACK FOOTER //
// ./src/App.js